import { useLocation, useNavigate } from "react-router-dom";
import { CustomLeftIcon } from "../../../common/StyledComponents/StyledFields";
import { useEffect } from "react";

const EventsHtmlContent = () => {
    const location = useLocation();
    console.log(location, "location");
    const navigate = useNavigate();

    const handlebackClick = () => {
        navigate('/')
    }
    useEffect(() => {
        window.scroll(0, 200)
    }, [])
    return (
        <div>
            <div onClick={handlebackClick} style={{marginLeft:"20px"}}>
                <CustomLeftIcon />
            </div>
            <div
                dangerouslySetInnerHTML={{ __html: location.state.key }} />

            {/* <iframe src={location.state.key} width="1000" height="800"></iframe> */}
        </div>
    );
};

export default EventsHtmlContent;
